<template>
  <div id="">
    <el-row>
      <el-col :span="4">
        <el-select v-model='pciwtype' xclearable placeholder="选择分类" size="small"
          @change="api_getProjectCircleImageWareList()">
          <el-option v-for="item in pciwtypearr||[]" :key="item.id" :label="item.type" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button v-if="addProjectCircleImageWare" @click=" $form('addProjectCircleImageWare')" type="primary" icon='el-icon-plus' size='small'
          style='margin-left:10px;'>
          新增项目图片模板
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div style="display: flex;width: 100%;flex-wrap: wrap;">
          <div v-for="item in data_getProjectCircleImageWareList" style="width: 18%;margin: 15px 10px; ">
            <div class="image" style="width: 100%;position: relative;" @click.stop="">
              <el-image :src="item.pciwPath" fit="fill" :preview-src-list="[item.pciwPath]"
                style='width: 100%;display: flex;flex-wrap: wrap;'> </el-image>
              <div class="btn" style="width: 100%;position: absolute; top: 40%;height:25%; display: flex;">
                <div style="width: 50%;text-align: center; z-index: 9;" @click.stop="pcidel(item.pciwId)"
                  v-if="theUserProject==0 && deleteProjectCircleImageWare">
                  <svg t="1631088812691" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="2275" width="48" height="48">
                    <path
                      d="M514.133333 840.533333c12.8 0 21.333333-8.533333 21.333334-21.333333v-384c0-12.8-8.533333-21.333333-21.333334-21.333333s-21.333333 8.533333-21.333333 21.333333v384c0 10.666667 8.533333 21.333333 21.333333 21.333333zM684.8 840.533333c12.8 0 21.333333-8.533333 21.333333-21.333333v-384c0-12.8-8.533333-21.333333-21.333333-21.333333s-21.333333 8.533333-21.333333 21.333333v384c0 10.666667 8.533333 21.333333 21.333333 21.333333zM343.466667 840.533333c12.8 0 21.333333-8.533333 21.333333-21.333333v-384c0-12.8-8.533333-21.333333-21.333333-21.333333s-21.333333 8.533333-21.333334 21.333333v384c0 10.666667 8.533333 21.333333 21.333334 21.333333z"
                      fill="#8a8a8a" p-id="2276"></path>
                    <path
                      d="M938.666667 149.333333h-211.2V72.533333c0-23.466667-21.333333-51.2-44.8-51.2H341.333333c-23.466667 0-40.533333 25.6-40.533333 51.2V149.333333H85.333333c-12.8 0-21.333333 8.533333-21.333333 21.333334s8.533333 21.333333 21.333333 21.333333h66.133334v755.2C151.466667 981.333333 177.066667 1002.666667 213.333333 1002.666667h597.333334c36.266667 0 66.133333-21.333333 66.133333-55.466667V192H938.666667c12.8 0 21.333333-8.533333 21.333333-21.333333s-8.533333-21.333333-21.333333-21.333334zM343.466667 93.866667c0-12.8 6.4-29.866667 19.2-29.866667h298.666666c12.8 0 23.466667 17.066667 23.466667 29.866667V149.333333h-341.333333V93.866667z m490.666666 853.333333c0 12.8-10.666667 12.8-23.466666 12.8H213.333333c-12.8 0-19.2-2.133333-19.2-12.8V192h640v755.2z"
                      fill="#666666" p-id="2277">
                    </path>
                  </svg>
                </div>
                <div v-if="updateProjectCircleImageModel" style="width: 50%;text-align: center;" @click.stop='pciwset(item.pciwType,item.pciwPath)'>
                  <svg t="1631089337382" class="icon" viewBox="0 0 1026 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="8846" width="48" height="48">
                    <path
                      d="M983.835253 313.365707a511.93705 511.93705 0 1 0 40.120847 198.662243 508.618063 508.618063 0 0 0-40.120847-198.662243z m-58.751776 372.474581a448.141293 448.141293 0 1 1 35.077866-173.812338 445.131305 445.131305 0 0 1-35.077866 173.812338z"
                      p-id="8847" fill="#8a8a8a"></path>
                    <path
                      d="M724.327241 359.61653a95.802635 95.802635 0 0 0-135.324484 0L476.224186 472.395101l-22.557914-22.557914a95.692636 95.692636 0 1 0-135.325484 135.325484l90.220656 90.220657a95.802635 95.802635 0 0 0 135.325485 0L724.308241 494.962015a95.802635 95.802635 0 0 0 0-135.325485z m-45.104828 90.220657L498.8021 630.2585a31.897879 31.897879 0 0 1-45.105828 0l-90.219656-90.220657a31.897879 31.897879 0 0 1 45.114828-45.104828l45.104828 45.114828a31.897879 31.897879 0 0 0 45.105828 0L634.107585 404.722359a31.897879 31.897879 0 0 1 45.114828 45.114828z"
                      p-id="8848" fill="#8a8a8a"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>



        </div>

      </el-col>

    </el-row>

    <myform :viewobj='{
    addProjectCircleImageWare:[ "新增项目图片模板", "el-icon-circle-plus" ],
     $succeed$: api_getProjectCircleImageWareList
   }' @closed="$form('addProjectCircleImageWare','reset'); "
      @confirm='submitForm => $trigger("fileUpload").trigger(res=>res && submitForm())'>

      <template v-slot:pciwType='{Myformdata}'>
        <el-select v-model='Myformdata.pciwType' clearable placeholder="选择分类" size="small"
         >
          <el-option v-for="item in pciwtypearr||[]" :key="item.id" :label="item.type" :value="item.id">
          </el-option>
        </el-select>
        <!-- <el-input :rows="3" v-model='Myformdata.pciwType' type="number" placeholder="请输入模板类型"></el-input> -->
      </template>

      <template v-slot:pciwPath='{Myformdata}'>
        <myupload v-event.fileUpload='`
           return (Myformdata.pciwPath+"").startsWith("http")
             || ( (C = (await C.MyUpload()).file) ? Myformdata.pciwPath = C : false )
         `' @change='Myformdata.pciwPath=($file$=arguments[0]).url'
          @remove='window.sleep(150,v=>Myformdata.pciwPath="")' type='image' :limit='1' :params='{ file: "$file$" }'
          :filelist='
           Myformdata.pciwPath
           ? ( { name: Myformdata.name, url: Myformdata.pciwPath } )
           : false
         ' x:style="{height: Myformdata.pciwPath && $form('updateCaseRecommend','ifshow') ? '250px' : ''}">
        </myupload>
      </template>
    </myform>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        theUserProject: "",
        pciwid: '',
        isshow: 0,
        previewSrcList: [],
        pciwtypearr: [{
            id: 1,
            type: "喜报",
          },
          {
            id: 2,
            type: "日报",
          },
          {
            id: 3,
            type: "周报",
          },
          {
            id: 4,
            type: "月报",
          },
          {
            id: 5,
            type: "打卡分享",
          },
          {
            id: 6,
            type: "订单分享",
          },
          {
            id: 7,
            type: "商机分享",
          },
        ],
        pciwtype: 2,
        data_getProjectCircleImageWareList: '',
      }
    },
    methods: {
      pciwset(r, e) {

        this.$confirm('是否应用该模板, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.getProjectCircleImageModelOne().result(res => {
            this.pcimid = res.data.data.pcimId
            console.log(this.pcimid)
            if (r == 1) {
              this.updateProjectCircleImageModel({
                pcimOrder: e,
                pcimId: this.pcimid
              }, '正在应用')
            } else if (r == 2) {
              this.updateProjectCircleImageModel({
                pcimDaily: e,
                pcimId: this.pcimid
              }, '正在应用')
            } else if (r == 3) {
              this.updateProjectCircleImageModel({
                pcimWeekly: e,
                pcimId: this.pcimid
              }, '正在应用')
            } else if(r==4) {
              this.updateProjectCircleImageModel({
                pcimMonthly: e,
                pcimId: this.pcimid
              }, '正在应用')
            }else if(r==5) {
              this.updateProjectCircleImageModel({
                pcimVisitorShare: e,
                pcimId: this.pcimid
              }, '正在应用')
            }else if(r==6) {
              this.updateProjectCircleImageModel({
                pcimOrderShare: e,
                pcimId: this.pcimid
              }, '正在应用')
            }else if(r==7) {
              this.updateProjectCircleImageModel({
                pcimOuShare: e,
                pcimId: this.pcimid
              }, '正在应用')
            }
          })

          this.$message({
            type: 'success',
            message: '应用成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消应用'
          });
        });






      },
      pcidel(e) {


        this.$confirm('此操作删除该模板, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteProjectCircleImageWare({
            pciwId: e
          }).trigger(res=>{
            // console.warn(res);
            window[ res.isuccess ? 'alertSuccess' : 'alertError' ]( '<div></div>', res.isuccess ? '删除成功！' : '删除失败！' );
            res.isuccess && this.api_getProjectCircleImageWareList();
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });


      },

      async api_getProjectCircleImageWareList() {

        await this.getProjectCircleImageWareList({
          pciwType: this.pciwtype
        }).trigger((res)=>{

           this.data_getProjectCircleImageWareList = res.data.data
        })

        // .result(res => {
        //   // if(!res) return;
        //   console.log(res.data.data)
        //   this.data_getProjectCircleImageWareList = res.data.data
        // })


      }
    },
    async created() {
      this.theUserProject = A.local('$projectId');
      if (this.theUserProject == 0) {
        this.getProjectList({
          pageSize: 0
        });
      } else {
        this.theProjectId = this.theUserProject;
      }
      await this.api_getProjectCircleImageWareList()
    }
  }
</script>

<style scoped="scoped">
  .btn {
    opacity: 0;
  }

  .image:hover .btn {
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/views/bussiness/ProjectCircleImageWare.vue